module.exports = __webpack_public_path__ + "img/sv.e85077b4.svg";